<template>
  <div class="privacy-page">
    <!-- 头部 -->
    <div class="header">
      <button class="back-btn" type="button" @click="goBack" :aria-label="$t('privacy.backLabel')">
        <span class="back-icon">‹</span>
      </button>
      <div class="header-title">{{ $t('privacy.title') }}</div>
    </div>

    <!-- 主要内容区 -->
    <div class="main-content">
      <div class="content-card">
        <div class="section-title">{{ $t('privacy.section1.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section1.content') }}</div>

        <div class="section-title">{{ $t('privacy.section2.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section2.intro') }}</div>
        <div v-for="(item, idx) in $t('privacy.section2.items')" :key="'s2-'+idx" class="list-item">
          {{ item }}
        </div>

        <div class="section-title">{{ $t('privacy.section3.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section3.intro') }}</div>
        <div v-for="(item, idx) in $t('privacy.section3.items')" :key="'s3-'+idx" class="list-item">
          {{ item }}
        </div>

        <div class="section-title">{{ $t('privacy.section4.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section4.para1') }}</div>
        <div class="paragraph">{{ $t('privacy.section4.para2') }}</div>

        <div class="section-title">{{ $t('privacy.section5.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section5.intro') }}</div>
        <div v-for="(item, idx) in $t('privacy.section5.items')" :key="'s5-'+idx" class="list-item">
          {{ item }}
        </div>

        <div class="section-title">{{ $t('privacy.section6.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section6.intro') }}</div>
        <div v-for="(item, idx) in $t('privacy.section6.items')" :key="'s6-'+idx" class="list-item">
          {{ item }}
        </div>
        <div class="paragraph">{{ $t('privacy.section6.additionalNote') }}</div>

        <div class="section-title">{{ $t('privacy.section7.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section7.para1') }}</div>
        <div class="paragraph">{{ $t('privacy.section7.para2') }}</div>

        <div class="section-title">{{ $t('privacy.section8.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section8.content') }}</div>

        <div class="section-title">{{ $t('privacy.section9.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section9.para1') }}</div>
        <div class="paragraph">{{ $t('privacy.section9.para2') }}</div>

        <div class="section-title">{{ $t('privacy.section10.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section10.content') }}</div>

        <div class="section-title">{{ $t('privacy.section11.title') }}</div>
        <div class="paragraph">{{ $t('privacy.section11.content') }}</div>

        <div class="section-title">{{ $t('privacy.section12.title') }}</div>
        <div class="paragraph">
          {{ $t('privacy.section12.contactLine1') }}<br>
          {{ $t('privacy.section12.contactLine2') }}
        </div>

        <div class="paragraph">{{ $t('privacy.effectiveDate') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  mounted() {
    document.title = this.$t('privacy.title')
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.privacy-page {
  max-width: 450px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Segoe UI", sans-serif;
}

.header {
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 8px 14px;
  background: rgba(245, 245, 247, 0.86);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  position: sticky;
  top: 0;
  z-index: 10;
}

.back-btn {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #007aff;
  font: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;
}

.back-btn:active {
  background: rgba(0, 122, 255, 0.1);
  transform: scale(0.96);
}

.back-icon {
  display: block;
  margin-top: -1px;
  font-size: 34px;
  font-weight: 300;
  line-height: 1;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: 0;
  margin-right: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main-content {
  flex: 1;
  padding: 18px 16px 56px;
  overflow-y: auto;
}

.content-card {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 18px;
  padding: 24px 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

.section-title {
  font-size: 17px;
  font-weight: 650;
  color: #1d1d1f;
  margin: 28px 0 9px;
  line-height: 1.35;
  letter-spacing: 0;
}

.section-title:first-of-type {
  margin-top: 0;
}

.paragraph {
  font-size: 14px;
  color: #3a3a3c;
  margin-bottom: 14px;
  line-height: 1.72;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
}

.list-item {
  font-size: 14px;
  color: #3a3a3c;
  margin-bottom: 9px;
  padding-left: 18px;
  position: relative;
  line-height: 1.68;
  letter-spacing: 0;
  word-break: break-word;
}

.list-item::before {
  content: "";
  position: absolute;
  top: 0.78em;
  left: 3px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #007aff;
}
</style>
